import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HotelDetailPage = lazy(() => import('../pages/hotel-detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HotelDetailPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;